import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { get, set } from 'lodash/fp';
import { InMemoryCache } from '@apollo/client/cache';
import { SetContextLink } from '@apollo/client/link/context';

const setAuthHeader = ({ isProduction, token }: { isProduction: boolean; token?: string }) =>
  new SetContextLink((context) => {
    if (isProduction || !token) {
      return context;
    }
    return set('headers.authorization', `Bearer ${token}`, context);
  });

// This creates the CMS client for the server side logic and CMS interactions, with the client having a similar copy of this
// code. Any changes done to this file needs to be replicated on the server's CMS client as well (particularly the createClient
// and getUri methods). These would most probably get combined when Next.js is implemented.
const createClient = (config: any, _dataset: unknown, _mode: unknown, uri: string) => {
  const sanityConfig = config.get('sanity');
  const sanityApiToken = process.env.SANITY_API_TOKEN;
  const isProduction = get('NODE_ENV', config) === 'production';
  const cache = new InMemoryCache();
  const fetchPolicy = sanityConfig.fetchPolicy.server;
  const opts = {
    cache,
    clientAwareness: { name: 'sanity-sales' },
    defaultOptions: {
      query: {
        fetchPolicy,
      },
      watchQuery: {
        fetchPolicy,
      },
    },
    devtools: { enabled: !isProduction },
    link: ApolloLink.from([
      // draft documents are only returned with an api token
      setAuthHeader({ isProduction, token: sanityApiToken }),
      new HttpLink({ uri }),
    ]),
    ssrMode: true,
  };
  return new ApolloClient(opts);
};

export default createClient;
